import React from "react";
import { Box, IconButton, Tooltip, styled } from "@mui/material";
import { NavLink, useLocation } from "react-router-dom";
import Logo from "../../../assets/images/tapxlogobalck.png";
import { listItems } from "../../../utils/navigation";

const SidebarContainer = styled(Box)(({ theme }) => ({
    position: "fixed",
    left: "20px",
    top: "20px",
    bottom: "20px",
    width: "80px",
    backgroundColor: "rgba(255, 255, 255, 0.8)",
    backdropFilter: "blur(20px)",
    borderRadius: "24px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "30px 0",
    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.05)",
    border: "1px solid rgba(255, 255, 255, 0.4)",
    zIndex: 1300,
    transition: "all 0.3s ease",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
        display: "none"
    }
}));

const LogoBox = styled(Box)({
    marginBottom: "40px",
    "& img": {
        width: "45px",
        height: "auto",
        borderRadius: "10px",
        filter: "drop-shadow(0 4px 6px rgba(0,0,0,0.1))"
    },
});

const NavItem = styled(NavLink)(({ theme }) => ({
    width: "50px",
    height: "50px",
    borderRadius: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "16px",
    color: "#8e9bb4",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    position: "relative",
    overflow: "hidden",

    "&:hover": {
        backgroundColor: "rgba(26, 35, 126, 0.05)",
        color: "#1a237e",
        transform: "translateY(-2px)",
    },

    "&.active": {
        backgroundColor: "#1a237e",
        color: "#fff",
        boxShadow: "0 8px 20px rgba(26, 35, 126, 0.3)",

        "& svg": {
            color: "#fff !important"  // Ensure icon color changes
        }
    },

    "& svg": {
        transition: "color 0.3s ease"
    }
}));

const AdminSidebar = () => {
    const location = useLocation();

    return (
        <SidebarContainer>
            <LogoBox>
                <img src={Logo} alt="Logo" />
            </LogoBox>

            {listItems.map((item, index) => {
                // Clone element to override color to 'inherit' so CSS handles it
                const Icon = React.cloneElement(item.icon, { color: "currentColor", size: 24, variant: "Outline" });

                return (
                    <Tooltip title={item.head} placement="right" arrow key={index} componentsProps={{
                        tooltip: {
                            sx: {
                                bgcolor: '#1a237e',
                                '& .MuiTooltip-arrow': {
                                    color: '#1a237e',
                                },
                                fontSize: '0.85rem',
                                py: 1,
                                px: 2,
                                borderRadius: '10px'
                            }
                        }
                    }}>
                        <NavItem to={item.link}>
                            {Icon}
                        </NavItem>
                    </Tooltip>
                );
            })}
        </SidebarContainer>
    );
};

export default AdminSidebar;
